import { render, staticRenderFns } from "./modalCamera.vue?vue&type=template&id=58e871d2&scoped=true&"
import script from "./modalCamera.vue?vue&type=script&lang=js&"
export * from "./modalCamera.vue?vue&type=script&lang=js&"
import style0 from "./modalCamera.vue?vue&type=style&index=0&id=58e871d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e871d2",
  null
  
)

export default component.exports